import styled from "@emotion/styled";

export const Root = styled.div({
    width: "100%",
    position: "relative",
});

export const LeftArrow = styled.div(_ => ({
    width: 50,
    height: 50,
    position: "fixed",
    textAlign: "center",
    zIndex: 201,
    bottom: "50%",
    userSelect: "none",
    cursor: "pointer",
    marginLeft: 17,
}));

export const RightArrow = styled.div(_ => ({
    width: 50,
    height: 50,
    position: "fixed",
    textAlign: "center",
    zIndex: 201,
    bottom: "50%",
    userSelect: "none",
    cursor: "pointer",
    right: 0,
}));

export const Inner = styled.div<{ unit: boolean }>(props =>
    props.unit
        ? {
              overflow: "hidden",
              padding: "0 40px 80px",
              margin: "0 -40px",
          }
        : {
              overflowX: "hidden",
              paddingBottom: 20,
              margin: "0 -40px",
          }
);

export const ScrollBarContainer = styled.div<{ fixed?: boolean; unit?: boolean }>(props =>
    props.fixed
        ? {
              position: "fixed",
              left: 40,
          }
        : props.unit
          ? {
                position: "absolute",
                zIndex: 101,
                bottom: 40,
            }
          : { position: "absolute", zIndex: 101 }
);

export const ScrollBar = styled.div(props => ({
    bottom: 20,
    height: 12,
    background: props.theme.candy.keyPalette.panel2BackgroundColor,
    borderRadius: 6,
    zIndex: 501,
    overflowX: "auto",
}));

export const Scroll = styled.div(props => ({
    position: "absolute",
    right: 2,
    transition: "width 0.2s",
    width: 4,
    zIndex: 10,
    height: 12,

    ":after": {
        background: props.theme.candy.legacy.scrollBarBackgroundColor,
        borderRadius: 5,
        bottom: 1,
        content: "''",
        display: "block",
        left: 0,
        position: "absolute",
        right: 0,
        top: 1,
    },
}));
